import { useCallback, useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { ThemeMode } from 'c-lib';
import { themeModeForPath } from 'c-lib';

const atom_themeMode = atomWithStorage<ThemeMode>('theme-mode', 'light');

function useThemeMode() {
    const [storedMode, setMode] = useAtom(atom_themeMode);
    const mode = themeModeForPath(storedMode, window.location.pathname);
    const toggleMode = useCallback(
        () => setMode(current => (current === 'dark' ? 'light' : 'dark')),
        [setMode],
    );

    return useMemo(
        () => ({ mode, isDarkMode: mode === 'dark', setMode, toggleMode }),
        [mode, setMode, toggleMode],
    );
}

export default useThemeMode;
